@let viewConfig = this.pageViewConfig();
@let table = this.table();
@let currentLanguage = this.currentLanguage();

@if (viewConfig.theme?.background?.image; as image) {
  <app-image
    class="bg-image"
    [image]="image | imageTranslate: currentLanguage"
    alt="Background Image"
  />
}

<app-header
  class="header"
  coreActivitySection="Header"
  [pageName]="pageName() | textTranslate: 'fallback'"
  [backSwipe]="backSwipeConfig"
>
  @if (viewConfig.header && viewConfig.header.title && viewConfig.header.title.text) {
    <app-header-text slot="center" [text]="viewConfig.header.title.text | textTranslate: currentLanguage"/>
  }

  @if (!viewConfig.header || !viewConfig.header.badge ||
  (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'table-name')) {
    <app-header-badge-table-name slot="right"/>
  } @else if (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'text') {
    <app-header-badge-text slot="right" [text]="viewConfig.header.badge.text | textTranslate: currentLanguage"/>
  }
</app-header>

@if (viewConfig.logo) {
  @let logo = viewConfig.logo | imageTranslate: currentLanguage;

  <div class="logo">
      <app-image
          class="image"
          [image]="logo"
      alt="Logo"
    />
  </div>
}

@if (viewConfig.title) {
  <app-text class="title">{{ viewConfig.title | textTranslate: currentLanguage }}</app-text>
}

<app-call-waiter-buttons
  class="call-waiter-buttons"
  coreActivitySection="CallWaiter"
  [config]="viewConfig.callWaiter"
/>

<div class="amenities">
  <div class="item">
    @if (viewConfig.amenities.chargePhone.icon; as icons) {
      @let icon = icons | imageTranslate: currentLanguage;

      <app-image
        class="icon"
        [image]="icon"
        [alt]="viewConfig.amenities.chargePhone.title | textTranslate: currentLanguage"
      />
    }

    <app-text class="title">{{ viewConfig.amenities.chargePhone.title | textTranslate: currentLanguage }}</app-text>

    @if (viewConfig.amenities.chargePhone.description; as description) {
      <app-text class="description">{{ description | textTranslate: currentLanguage }}</app-text>
    }
  </div>

  @if (table && table?.wifiName) {
    <div class="item">
      @if (viewConfig.amenities.wifi.icon; as icons) {
        @let icon = icons | imageTranslate: currentLanguage;

          <app-image
          class="icon"
          [image]="icon"
          [alt]="viewConfig.amenities.wifi.title | textTranslate: currentLanguage"
        />
      }

      <app-text class="title">{{ viewConfig.amenities.wifi.title | textTranslate: currentLanguage }}</app-text>

      <div class="fields">
        <div class="field">
          <app-text class="label">{{ viewConfig.amenities.wifi.sid.label | textTranslate: currentLanguage }}:</app-text>
          <app-text class="value">{{ table.wifiName }}</app-text>
        </div>

        @if (table.wifiPassword) {
          <div class="field">
            <app-text class="label">{{ viewConfig.amenities.wifi.password.label | textTranslate: currentLanguage }}:
            </app-text>
            <app-text class="value">{{ table.wifiPassword }}</app-text>
          </div>
        }
      </div>
    </div>
  }
</div>
